import Vue from "Vue";
import { Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class InputTime extends Vue {
    @Prop()
    private vmodel;

    @Prop({ default: "" })
    public label;

    @Prop({ default: false })
    private disabled;

    @Prop({ default: false })
    private required;

    @Prop({ default: true })
    private show;

    @Prop({ default: false })
    private error;

    @Prop({ default: false })
    private isBackgroundGrey;

    public value;

    constructor() {
        super();
        this.value = "";
    }

    @Watch('vmodel', { immediate: true })
    private setValue(): void {
        if (this.vmodel == null) {
            this.value = "00:00";
        } else {
            var dateVmodel = new Date(this.vmodel);
            this.value = moment(new Date(Date.UTC(dateVmodel.getUTCFullYear(), dateVmodel.getUTCMonth(), dateVmodel.getUTCDate(), dateVmodel.getUTCHours(), dateVmodel.getUTCMinutes()))).format("HH:mm");
        }
    }

    public focus(e): void {
        e.target.select();
    }

    public blur(e): void {
        var date = new Date("2022-01-01" + ' ' + e.target.value);
        var dateMoment = moment(new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes())));
        this.$emit('update:vmodel', dateMoment.format("YYYY-MM-DDTHH:mm:ss"));
        this.$emit('changed');
    }

    public paste(e): void {
        e.preventDefault();
    }
}



// WEBPACK FOOTER //
// ./src/shared/components/InputTime/InputTime.ts